import { NgModule } from '@angular/core';
import { PipelineFilterPackageSelectorComponent } from './pipeline-filter-package-selector.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipelineFilterPackageStoreService } from './pipeline-filter-package-store.service';
import { FormsModule } from '@angular/forms';
import { PipelineFilterPackageSelectionService } from './pipeline-filter-package-selection.service';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ItemSearchSelectFilterModule } from '@galaxy/inventory-ui';
import { Observable } from 'rxjs';
import { MARKET_ID_TOKEN, PACKAGE_SELECT_CONFIG_TOKEN, PARTNER_ID_TOKEN, PackageSelectConfig } from './tokens';

@NgModule({
  declarations: [PipelineFilterPackageSelectorComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,
    ItemSearchSelectFilterModule,
  ],
  providers: [
    PipelineFilterPackageStoreService,
    PipelineFilterPackageSelectionService,
    { provide: PARTNER_ID_TOKEN, deps: [PACKAGE_SELECT_CONFIG_TOKEN], useFactory: partnerIdFactory },
    { provide: MARKET_ID_TOKEN, deps: [PACKAGE_SELECT_CONFIG_TOKEN], useFactory: marketIdFactory },
  ],
})
export class PipelineFilterPackageSelectorModule {}

function partnerIdFactory(config: PackageSelectConfig): Observable<string> {
  return config.partnerId$;
}

function marketIdFactory(config: PackageSelectConfig): Observable<string> {
  return config.marketId$;
}
